import React from 'react';
import PerSurfVersionSelectBar from './PerSurfVersionSelectBar';
import PerSurfVersionCompareSelectBar from './PerSurfVersionCompareSelectBar';
import webapi from '../../../api/webapi';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';



class PerSurfSearchBox extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = { BookGroups: [] };
        this.state = { books: [] };
        this.state = { chapters: [] };

        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedBook: '' };
        this.state = { SelectedChapter: '' };
       
    }

    componentDidMount() {
        this.setState({loadingShow:true})
        this.setState({ SelectedBook: '' });
        this.setState({ SelectedChapter: '' });

        this.GetBookGroups();

        this.setState({loadingShow:false})
    };

    GetBookGroups = async () =>{
        await webapi.get('persiansurf/allbookgroups/'+this.props.Lang)
            .then(response => {
                this.setState({ BookGroups: response.data},() => {} );
            })
            .catch(function(err) {
                //console.log(err);
                this.setState({ BookGroups: undefined},() => {} );
              });
        if (this.state.BookGroups!==undefined && this.state.BookGroups.length>0)
        {
            this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
            this.GetBooks(this.state.BookGroups[0].Code)
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }
    }

    GetBooks = async BookGroupCode =>{
        this.setState({loadingShow:true})
        await webapi.get('persiansurf/bookgroupsbook/'+BookGroupCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ books: response.data });
            })
            .catch(function(err) {
                //console.log(err);
                this.setState({ BookGroups: undefined},() => {} );
              });
       if (this.state.books!==undefined)
       {
           this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
           this.GetChapters(this.state.books[0].Code)
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }                
    }

    GetChapters = async BookCode =>{
        this.setState({loadingShow:true})
        await webapi.get('persiansurf/bookschapter/'+ BookCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ chapters: response.data });
            })
       if (this.state.chapters!==undefined)
       {
           this.setState({ SelectedChapter : this.state.chapters[0].Code })
       }
       this.setState({loadingShow:false})        
    }

    onChangeBookGroupSelect = async event => {
        this.setState({loadingShow:true})
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({loadingShow:true})
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    onSelectTab = (tabIndex)=>{
        this.setState({ tabIndex : tabIndex});
        this.props.onSelectTab(tabIndex);
    }

    render() {
        return (
            [
                <div className="container-fluid" id="words_search_form">
                    <div className="container">
                        <br />
                        <div className="select_param">           
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F80101!== undefined?this.props.pageData[0].F80101:80101/*نوع متن*/}</label>
                            <select className="" id='select' onChange={this.onChangeBookGroupSelect}>
                                {   this.state.BookGroups != null 
                                    ?
                                    (   
                                        this.state.BookGroups.map((bookgroup) =>{
                                            return  (
                                                <option key={'bg'+bookgroup.Code} value={bookgroup.Code}>{bookgroup.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="bg-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param">           
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F80102!== undefined?this.props.pageData[0].F80102:80102/*نام متن*/}</label>
                            <select onChange={this.onChangeBookSelect} className="">
                                {   this.state.books != null 
                                    ?
                                    (   
                                        this.state.books.map((book) =>{
                                            return  (
                                                <option key={'b'+book.Code} value={book.Code}>{book.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="b-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param">           
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F80103!== undefined?this.props.pageData[0].F80103:80103/*شماره فصل*/}</label>
                            <select onChange={this.onChangeChapterSelect}  className="">
                                {   this.state.chapters != null 
                                    ?
                                    (   this.state.chapters.map((chapter,i) =>{
                                            return  (
                                                (this.state.chapters.length>1 && i===0)
                                                ?
                                                (
                                                    [
                                                        <option key={i+'j'+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                    ]
                                                )
                                                :
                                                (
                                                    <option key={i+'k'+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                )
                                            )
                                        })
                                    )
                                    :
                                    <option key="c-1">{this.props.pageData.length!==0 && this.props.pageData[0].F89902!== undefined?this.props.pageData[0].F89902:89902/*همه*/}</option>       
                                }
                            </select>
                        </div>
                        <br />
                        <Tabs   className ="search-tab"
                                selectedTabPanelClassName="search_tab-panel--selected" 
                                selectedTabClassName="search_tab--selected"
                                disabledTabClassName="search_tab--disabled"
                                selectedIndex={this.props.tabIndex} 
                                onSelect={tabIndex => this.setState({ tabIndex })}//onSelect={(tabIndex ) => this.onSelectTab(tabIndex)} 
                        >
                            <TabList className="search-tab-list">
                                <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F80104!== undefined?this.props.pageData[0].F80104:80104/*متون*/}</Tab>
                                <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F80105!== undefined?this.props.pageData[0].F80105:80205/*مقایسه متون*/}</Tab>
                            </TabList>

                            <TabPanel className ="search_tab-panel">
                                <PerSurfVersionSelectBar       key={this.state.SelectedChapter}
                                                            SelectedBook={this.state.SelectedBook}
                                                            SelectedChapter={this.state.SelectedChapter}
                                                            pageData={this.props.pageData}
                                />
                            </TabPanel>
                            <TabPanel className ="search_tab-panel">
                                <PerSurfVersionCompareSelectBar    key={this.state.SelectedChapter}
                                                                SelectedBook={this.state.SelectedBook}
                                                                SelectedChapter={this.state.SelectedChapter}
                                                                pageData={this.props.pageData}
                                />                          
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
                ,
                <Loading loadingShow={this.state.loadingShow} />
            ]
        )
    }
}

export default PerSurfSearchBox;